import React from 'react'
import responsiveStyles from '../styles/responsive.module.scss'
import { css } from "@emotion/core"
import { Link } from "gatsby"
// Iconos
import { RiWindowLine } from "react-icons/ri";
import { MdPermPhoneMsg } from "react-icons/md";
import { FaRegFolderOpen } from "react-icons/fa"


const ResponsiveBar = () => {

    return(

        <div className={responsiveStyles.wrapper}>
            <Link to="/diseno-web-sevilla" className={responsiveStyles.wrapper_button}>
                    <RiWindowLine css={css`width:25px; height:25px;`}/>
                    <p>diseño web</p>
            </Link>


            <Link to="/portfolio" className={responsiveStyles.wrapper_button}>
                    <FaRegFolderOpen css={css`width:25px; height:25px;`}/>
                    <p>portfolio</p>
            </Link>

            <Link to="/contacto" className={responsiveStyles.wrapper_button}>
                    <MdPermPhoneMsg css={css`width:25px; height:25px;`}/>
                    <p>contacta</p>
            </Link>
        </div>


    )
}

export default ResponsiveBar